import { InitFeatureParams } from '../types'
import { getRoutes } from './routes'

export const initSystemSetting = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
